var _path, _path2, _path3, _defs;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRoadmap = function SvgRoadmap(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1941 22.6314C10.3715 21.6855 11.1974 21 12.1599 21H23.8401C24.8026 21 25.6285 21.6855 25.8059 22.6314L26.5559 26.6314C26.7867 27.8622 25.8424 29 24.5901 29H11.4099C10.1576 29 9.21333 27.8623 9.44411 26.6314L10.1941 22.6314Z",
    fill: "#2595FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9776 26.0975L18.0008 26.1028L18.0239 26.0971C18.2142 26.0503 18.4631 25.8835 18.7447 25.6412C19.0308 25.395 19.3641 25.0587 19.7248 24.654C20.4466 23.8443 21.2832 22.755 22.0781 21.5515C22.8728 20.348 23.6273 19.0281 24.1833 17.7568C24.7386 16.4875 25.1 15.2579 25.1 14.2381C25.1 10.1886 21.9243 6.9 18 6.9C14.0757 6.9 10.9 10.1886 10.9 14.2381C10.9 15.2576 11.2555 16.487 11.8035 17.7563C12.3524 19.0276 13.0981 20.3476 13.8872 21.5512C14.6763 22.7548 15.5102 23.8443 16.2365 24.6542C16.5995 25.059 16.937 25.3955 17.2297 25.6419C17.5183 25.8848 17.7759 26.0511 17.9776 26.0975ZM20.7 13.7857C20.7 15.2266 19.4942 16.4 18 16.4C16.5059 16.4 15.3 15.2266 15.3 13.7857C15.3 12.3448 16.5059 11.1714 18 11.1714C19.4942 11.1714 20.7 12.3448 20.7 13.7857Z",
    stroke: "url(#paint0_linear_54_596)",
    strokeOpacity: 0.6,
    strokeWidth: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 26C19.3189 25.6754 25 18.2356 25 14.2381C25 10.2406 21.866 7 18 7C14.134 7 11 10.2406 11 14.2381C11 18.2356 16.5889 25.6754 18 26ZM18 16.5C19.5464 16.5 20.8 15.2848 20.8 13.7857C20.8 12.2866 19.5464 11.0714 18 11.0714C16.4537 11.0714 15.2 12.2866 15.2 13.7857C15.2 15.2848 16.4537 16.5 18 16.5Z",
    fill: "#67B6FE",
    fillOpacity: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_54_596",
    x: 2.80005,
    y: -1.2,
    width: 30.3999,
    height: 35.4056,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_54_596"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_54_596",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_54_596",
    x: 7,
    y: 3,
    width: 22,
    height: 27,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_54_596"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_54_596",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_54_596",
    x1: 10,
    y1: 8.72727,
    x2: 31.8889,
    y2: 17.0549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRoadmap, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Roadmap.d78b61af.svg";
export { ForwardRef as ReactComponent };